import React from 'react';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import {LocalDate} from "js-joda";
import * as DateUtil from "../../utils/DateUtil";

const AvailabilityRangeMobile = ({criteria, showRate, displayNoOfNights, onToggleShowRate, onChangeRange}) => {
  let startDate = DateUtil.localDateFromString(criteria.startDate);

  return(
      <div className="availabilityRange">
        <div className="availabilityRangeItem">
          <IconButton onClick={()=> onChangeRange(criteria, -validateDisplayNoOfNights(startDate, displayNoOfNights))} disabled={startDate.isEqual(LocalDate.now())} >
            <FontIcon className="material-icons">chevron_left</FontIcon>
          </IconButton>
          <label>Date</label>
          <IconButton onClick={()=> onChangeRange(criteria, displayNoOfNights)}>
            <FontIcon className="material-icons">chevron_right</FontIcon>
          </IconButton>
        </div>
      </div>
  )
};

const validateDisplayNoOfNights = (startDate, displayNoOfNights) => {
  let returnValue = displayNoOfNights;
  if(startDate.minusDays(displayNoOfNights).isBefore(LocalDate.now())) {
    returnValue = DateUtil.dateDiff(LocalDate.now(), startDate);
  }
  return returnValue;
};

export default AvailabilityRangeMobile


// WEBPACK FOOTER //
// ./src/components/mobile/AvailabilityRangeMobileComponent.js